<script setup lang="ts">
import { useValidationError } from "@vm/validation";

const props = defineProps<{
  helpText?: string;
  label?: string;
  fullPath: string;
}>();

const modelValue = defineModel<string>({ required: true });

const { validationError, resetValidation } = useValidationError(props.fullPath);
</script>

<template>
  <div class="flex w-full flex-col">
    <label v-if="label" class="text-xs text-gray-800" :for="fullPath">
      {{ label }}
    </label>
    <div class="flex items-center gap-1">
      <input
        :id="`${fullPath}_color`"
        v-model="modelValue"
        type="color"
        class="h-10 w-10 cursor-pointer rounded border border-gray-300"
        :class="{ 'border-red-500': !!validationError }"
        @input="() => resetValidation()"
      />
      <input
        :id="fullPath"
        v-model="modelValue"
        type="text"
        class="tableau-tooltip flex-1 rounded border border-gray-300 px-3 py-2 text-sm"
        :class="{ 'border-red-500': !!validationError }"
        placeholder="#00c950"
        maxlength="7"
        @input="() => resetValidation()"
      />
    </div>
    <small v-if="helpText" class="text-xs text-gray-800">{{ helpText }}</small>
    <small v-if="validationError?.message" class="text-red-600">
      {{ validationError?.message }}
    </small>
  </div>
</template>
